// checkout_block_viewed events only started being collected on this date.
// Experiences whose data reaches before it have an incomplete block-view series.
export const CHECKOUT_BLOCK_VIEWED_AVAILABLE_FROM =
  "2026-06-16T00:00:00.000+00:00";

/**
 * How many *removable* filter chips render in an analytics header before the
 * rest collapse into "+N". The row is `nowrap` inside a fixed-height bar, hence
 * the cap. The analytics exclusions chip is not a removable filter and sits
 * outside this budget.
 */
export const MAX_VISIBLE_FILTER_CHIPS = 3;
